import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Boot from './redux/boot';
import Routes from './router';
import AppProvider from './AppProvider';
import { hot } from 'react-hot-loader/root';
import { OpenCvProvider } from 'opencv-react';
import FaceImage from '@app/assets/images/user1.png';
import * as faceapi from 'face-api.js';

/** Start::Styles CSS | GVL01767 2023-04-26 */
import CoreStyles from '@app/assets/styles/coreStyle';
import StepperStyles from '@app/assets/styles/stepperStyle';
import DocsPopupStyles from '@app/assets/styles/docsPopupStyle';
import StepOneStyles from '@app/assets/styles/stepOneStyle';
import StepTwoStyles from '@app/assets/styles/stepTwoStyle';
import StepThreeStyles from '@app/assets/styles/stepThreeStyle';
import ErrorStyles from '@app/assets/styles/errorStyle';
import SuccessStyles from '@app/assets/styles/successStyle';

/** End::Styles CSS | GVL01767 2023-04-26 */

const App = () => {
  /* Start::Get all local storage then check and remove they | GVL01767 2023-08-09 */
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    // Check to does not remove item that stored for showing popup welcome
    if (key && !key.includes('POPUP_WELCOME')) {
      localStorage.removeItem(key);
    }
  }
  /* End::Get all local storage then check and remove they | GVL01767 2023-08-09 */
  useEffect(() => {
    Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
      faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
    ]).then(async () => {
      let img = new Image();
      img.src = FaceImage;
      await faceapi
        .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions({ inputSize: 128 }))
        .withFaceLandmarks();
    });
  }, []);

  return (
    <OpenCvProvider openCvPath='/opencv/opencv.js'>
      <Provider store={store}>
        <AppProvider>
          <>
            <CoreStyles />
            <StepperStyles />
            <DocsPopupStyles />
            <StepOneStyles />
            <StepTwoStyles />
            <StepThreeStyles />
            <ErrorStyles />
            <SuccessStyles />
            <Routes />
          </>
        </AppProvider>
      </Provider>
    </OpenCvProvider>
  );
};

Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default process.env.NODE_ENV === 'development' ? hot(App) : App;
